import { head, split } from 'lodash/fp';

import { INSURANCE_TYPES } from '../../../src/client/pages/insurance/constants';
import getStaticPathsForInsuranceTypes from '../utils/get-static-paths-for-insurance-types';
import LifeInsuranceContactUsPageComponent from '../../../src/client/pages/insurance/contact-us';

export const getStaticPaths = () =>
  getStaticPathsForInsuranceTypes([
    INSURANCE_TYPES.LIFE,
    INSURANCE_TYPES.CAR,
    INSURANCE_TYPES.HOME,
    INSURANCE_TYPES.PET,
  ]);

// @ts-expect-error - Automatic, Please fix when editing this file
export const getStaticProps = ({ params: { insuranceType } }) => {
  const type = head(split('-', insuranceType));
  return { props: { insuranceType: type } };
};

export default LifeInsuranceContactUsPageComponent;
